import React from 'react';
import { useTranslation } from 'react-i18next';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Typography } from '@mui/material';
import TooltipIconButton from 'components/ToolTipIconButton';
import { DateTime } from 'luxon';

interface PropsType {
	startDate: string;
}

function ProgramLessonLockStatus({ startDate }: PropsType) {
	const { t } = useTranslation();
	const formattedDate = DateTime.fromISO(startDate).toFormat('dd.MM.yyyy');

	return (
		<TooltipIconButton
			title={
				<Typography variant="body2" color="text.primary">
					{t('program.lessonOpenIn', { date: formattedDate })}
				</Typography>
			}
			color="warning"
		>
			<LockOutlinedIcon sx={{ fontSize: '16px' }} />
		</TooltipIconButton>
	);
}

export default ProgramLessonLockStatus;
